import { toIntlLocale } from "@/i18n/to-intl-locale";

export function parseAsDate(
  timestamp: number | string | undefined,
): Date | undefined {
  if (!timestamp) return undefined;
  const numericTimestamp = Number(timestamp);
  const date = new Date(numericTimestamp);
  return !Number.isNaN(date.getTime()) ? date : undefined;
}
export function dateToTimestamp(date?: Date): number | undefined {
  return date ? date.getTime() : undefined;
}

export function toShortDate(date: Date, locale: string): string {
  return Intl.DateTimeFormat(toIntlLocale(locale), {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);
}

export function toShortDateTime(date: Date, locale: string): string {
  return Intl.DateTimeFormat(toIntlLocale(locale), {
    dateStyle: "short",
    timeStyle: "short",
  }).format(date);
}

export function toLongDate(date: Date, locale: string): string {
  return Intl.DateTimeFormat(toIntlLocale(locale), {
    year: "numeric",
    month: "long",
    day: "numeric",
  }).format(date);
}

export function toDayOfWeek(date: Date, locale: string): string {
  return Intl.DateTimeFormat(toIntlLocale(locale), {
    weekday: "long",
  }).format(date);
}
